// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
require('./_set-collection-of')('WeakSet');



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/core-js/modules/es7.weak-set.of.js
// module id = ../../node_modules/core-js/modules/es7.weak-set.of.js
// module chunks = 18